import { useState, useEffect } from "react";

export function TimeInput({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  const [h, m] = value.split(":");
  const [draftH, setDraftH] = useState(h);
  const [draftM, setDraftM] = useState(m);
  const [editingH, setEditingH] = useState(false);
  const [editingM, setEditingM] = useState(false);

  // Sync from parent when not editing
  useEffect(() => {
    if (!editingH) setDraftH(h);
  }, [h, editingH]);
  useEffect(() => {
    if (!editingM) setDraftM(m);
  }, [m, editingM]);

  const commitH = () => {
    const num = parseInt(draftH, 10);
    const clamped = isNaN(num) ? 0 : Math.min(23, Math.max(0, num));
    const padded = String(clamped).padStart(2, "0");
    setDraftH(padded);
    setEditingH(false);
    onChange(`${padded}:${m}`);
  };

  const commitM = () => {
    const num = parseInt(draftM, 10);
    const clamped = isNaN(num) ? 0 : Math.min(59, Math.max(0, num));
    const padded = String(clamped).padStart(2, "0");
    setDraftM(padded);
    setEditingM(false);
    onChange(`${h}:${padded}`);
  };

  return (
    <div className="inline-flex items-center rounded-lg border border-input bg-background">
      <input
        type="text"
        inputMode="numeric"
        maxLength={2}
        value={editingH ? draftH : h}
        onFocus={() => setEditingH(true)}
        onChange={(e) => setDraftH(e.target.value.replace(/\D/g, ""))}
        onBlur={commitH}
        onKeyDown={(e) => e.key === "Enter" && commitH()}
        className="h-8 w-10 bg-transparent text-center text-sm font-medium text-foreground outline-none"
      />
      <span className="text-sm font-bold text-muted-foreground">:</span>
      <input
        type="text"
        inputMode="numeric"
        maxLength={2}
        value={editingM ? draftM : m}
        onFocus={() => setEditingM(true)}
        onChange={(e) => setDraftM(e.target.value.replace(/\D/g, ""))}
        onBlur={commitM}
        onKeyDown={(e) => e.key === "Enter" && commitM()}
        className="h-8 w-10 bg-transparent text-center text-sm font-medium text-foreground outline-none"
      />
    </div>
  );
}
